// TODO: resolve CHCP disables by bot
// eslint-disable-next-line @typescript-eslint/naming-convention
export enum LOADING_STATE {
  loading = 'loading',
  error = 'error',
  loaded = 'loaded',
}
